import React from "react";

import Hero from "./sections/Hero";
import SolutionAmos from "./sections/Contact";
import Cards from "./sections/Cards";
import {Pricing} from "./sections/Pricing";
import Trust from "./sections/Trust";

const LandingPage = () => {
  return (
    <>
      <Hero page={0} />
      <Cards page={1} />
      <Trust page={3} />
      <Pricing page={4} />
      <SolutionAmos page={5} />
    </>
  );
};

export default LandingPage;
